import { Pipe, PipeTransform } from '@angular/core';

/**
 * Convert a duration in seconds into a string formatted as {x}h {y}min {z}s
 */
@Pipe({
  name: 'mibDuration',
})
export class MibDurationPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null || isNaN(value)) {
      return '';
    }

    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = value % 60;

    const parts: string[] = [];

    if (hours > 0) {
      parts.push(`${hours}h`);
    }
    if (minutes > 0 || hours > 0) {
      parts.push(`${minutes}min`);
    }
    if (parts.length === 0 || seconds > 0) {
      parts.push(`${seconds}s`);
    }

    return parts.join(' ');
  }
}
